import { CSSProperties } from 'react';
import { clsx } from 'clsx';
import { Menu, Tooltip, MenuItem, Icon, PopperPlacementType } from '@hevoio/hevo-ui-toolkit';
import { EntityAction } from '../../interfaces/entity-actions';

interface EntityMenuProps<T> {
  open: boolean;
  target: string;
  placement: PopperPlacementType;
  actions: EntityAction<T>[];
  style?: CSSProperties;
  onClose: VoidFunction;
  onActionClick: (action: EntityAction<T>) => void;
}

export function EntityMenu<T>({
  target,
  open,
  onClose,
  style,
  placement,
  actions,
  onActionClick
}: EntityMenuProps<T>) {
  return (
    <Menu
      target={`#${target}`}
      open={open}
      onClose={() => onClose()}
      dataId=''
      placement={placement}
      style={style}
    >
      {actions.map(action => (
        <Tooltip
          dataId={action.type}
          placement='left'
          title={action.disabledReason}
          disabled={!action.disabled}
          key={action.type as string}
        >
          <div>
            <MenuItem
              dataId={action.type}
              onClick={(e: MouseEvent) => {
                e.stopPropagation();

                onActionClick(action);
                onClose();
              }}
              disabled={action.disabled}
              selected={false}
            >
              <div className='d-flex'>
                <Icon
                  name={action.icon}
                  className={clsx('mr-2', action.className)}
                  dataId={action.type}
                />

                <div className='flex-col'>
                  <span className={clsx('text-medium', action.className)}>
                    {action.displayName}
                  </span>

                  <span className='mt-1 text-secondary text-normal text-wrap'>
                    {action.description}
                  </span>
                </div>
              </div>
            </MenuItem>
          </div>
        </Tooltip>
      ))}
    </Menu>
  );
}
